import React, {Component} from 'react';
import styled from 'styled-components/macro'
import EnvimationIcon from "../../../../shared-components/EnvimationIcon/EnvimationIcon";
import {ExternalLink} from "../../../../shared-components/RoutingLinks/RoutingLinks";
import PropTypes from "prop-types";

const MinReadText = styled.span`
    color: ${props => props.theme.grey};
    font-family: ${props => props.theme.highlightFontFamily};
    font-size: 0.8em;
    font-style: italic;
`;
const MinReadIcon = styled(EnvimationIcon).attrs({iconElement: "clock"})`
    color: ${props => props.theme.grey};
    && {
        top: 0.1em;
    }
`;

class MinRead extends Component {
    render() {
        return (
            <span>
                <MinReadIcon/>
                <MinReadText>{this.props.time} min. read</MinReadText>
            </span>
        )
    }
}

const AuthorText = styled.span`
    color: ${props => props.theme.greyHighlight};
    font-family: ${props => props.theme.highlightFontFamily};
    font-size: 0.8em;
    > a {
        color: ${props => props.theme.greyHighlight};
    }
    > a:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

class Author extends Component {
    constructor(props) {
        super(props);
        const authorName = this.props.name;
        const socialLink = this.props.link;
        let link;
        if(socialLink === "twitter") {
            link = "https://twitter.com/"+authorName;
        } else if(socialLink === "github") {
            link = "https://github.com/"+authorName;
        }

        this.state = {socialLink: link}
    }

    render() {
        return (
            <AuthorText>By <ExternalLink to={this.state.socialLink} displayText={this.props.name}/></AuthorText>
        )
    }
}

Author.propTypes = {
    link: PropTypes.oneOf(['twitter', 'github']).isRequired,
    name: PropTypes.string.isRequired

};

export {Author, MinRead}
